import { useMemo } from "react";
import { useDeviceDetector } from "@hooks/use-device-detector";
import styles from "./orientation-preview-container.less";
import { isInlineVideoSupported } from "@utils/device-util";
import { CaptureStep } from "@idw-types/data/capture-step";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import {
    getCaptureStepScreenOrientationMediaUrl,
    getCaptureStepScreenOrientationPreviewMessage,
    getCaptureStepShowScreenOrientationPreview
} from "@utils/capture-step-util";

type OrientationPreviewContainerProps = {
    captureStep: CaptureStep;
};

export const OrientationPreviewContainer = (props: OrientationPreviewContainerProps) => {
    const { captureStep } = props;
    const deviceInfo = useDeviceDetector();
    const content = useSelector(getLanguageContent);

    const showScreenOrientationPreview = getCaptureStepShowScreenOrientationPreview(captureStep.type, content);
    const orientationPreviewMessage = getCaptureStepScreenOrientationPreviewMessage(captureStep.type, content);

    const orientationPreviewContent = useMemo(() => {
        const showInlineVideo = isInlineVideoSupported(deviceInfo);
        const mediaUrl = getCaptureStepScreenOrientationMediaUrl(captureStep.type, content);
        if (showInlineVideo && mediaUrl && mediaUrl.includes(".mp4")) {
            return (
                <div className={styles.media}>
                    <video playsInline={true} autoPlay={true} muted={true} loop={true}>
                        <source src={mediaUrl} />
                    </video>
                </div>
            );
        } else if (mediaUrl) {
            return (
                <div className={styles.media}>
                    <img src={mediaUrl} />
                </div>
            );
        }
        return null;
    }, [deviceInfo]);

    return (
        <div className={styles.orientationPreviewContainer}>
            {showScreenOrientationPreview && orientationPreviewMessage && orientationPreviewMessage !== "." && (
                <span className={styles.previewMessage}>{orientationPreviewMessage}</span>
            )}
            {orientationPreviewContent}
        </div>
    );
};